import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
// import Cookies from 'js-cookie';
// import { H2, H3 } from 'components/redesign/src/components/base';
import Debugger from '../Debugger/Debugger';
import {
  handleShowOfferEvent,
  trackCheckoutCompleteEvent,
  trackCheckoutStageAuth,
  trackCheckoutStagePrintAddress,
  trackCheckoutStageState2,
  trackCheckoutStageReceipt,
  trackBackButtonClicked,
  trackShippingSaveEvent,
  trackCheckoutSelectTermEvent
} from '../../../utils/tracking/events/pianoEvents';
import { figureOutPriorityTag } from '../../../utils/ad_util';

export const UserContext = createContext({
  user: {},
  meter: {},
  activeOffer: {},
  journey: {}
});

export class UserProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      debugActive: false,
      user: {},
      meter: {},
      activeOffer: {},
      journey: {},
      currentDrawer: '1',
      offerPageDetails: {}
    };

    // binds
    this.logoutUser = this.logoutUser.bind(this);
    this.retriggerPianoPost = this.retriggerPianoPost.bind(this);
    this.onShowDrawer = this.onShowDrawer.bind(this);
  }

  componentDidMount() {
    if (get(window, 'location.search', '').includes('pdebug')) {
      // Activate local Piano debug display
      this.enableDebug();
    }

    // Handle initial user check
    if (!get(window, 'tp', undefined)) {
      window.tp = [];
    }
    window.tp.push([
      'init',
      () => {
        if (tp.pianoId.getUser()) { // eslint-disable-line
          this.setCurrentUser(tp.pianoId.getUser()); // eslint-disable-line
        }
      }
    ]);

    // Set default Piano handlers
    this.setPianoHandlers([
      'showOffer',
      'loginSuccess',
      'registerSuccess',
      'meterActive',
      'meterExpired',
      'checkoutComplete',
      'customEvent',
      'checkoutStateChange',
      'startCheckout',
      'checkoutSelectTerm'
    ]);

    // Listen for Custom Events
    // this.listenForTemplateEvents();

    // Setup listeners for custom Piano 'Composer' scripts
    this.listenForJourneyEvents([
      'meterProgressMessage',
      'subscribe',
      'showDrawer',
      'offerPage'
    ]);
  }

  // Fires when a user selects a term within an offer.
  onCheckoutSelectTerm(termDetails) {
    trackCheckoutSelectTermEvent(termDetails);
  }

  // Fires when a user begins checkout on a term.
  onStartCheckout(event) {} // eslint-disable-line

  // Offer checkout has completed
  onCheckoutComplete(event) {
    // const termId = get(event, 'termId', 'unknown-term')
    // Cookies.set(`converted-${termId}`, 'true', { expires: 30 });
    trackCheckoutCompleteEvent(event);
  }

  onCheckoutStateChange(stateView) {
    const { stateName } = stateView;

    switch (stateName) {
      case 'offer':
        // ------------------
        break;

      case 'auth':
        trackCheckoutStageAuth(stateView);
        break;

      case 'printAddress':
        trackCheckoutStagePrintAddress(stateView);
        break;

      case 'state2':
        trackCheckoutStageState2(stateView);
        break;

      case 'receipt':
        trackCheckoutStageReceipt(stateView);
        break;

      case 'alreadyHasAccess':
        // ------------------
        break;

      default:
        break;
    }
  }

  // Custom meter progress data from Piano
  onMeterProgressMessage(event) {
    const { journey } = this.state;
    const displayMessageFlag = get(event, 'displayMessageFlag', true);
    const displayMessageAt = get(event, 'displayMessageAt', -1);
    const templateId = get(event, 'templateId', 'OTQHXLVJIG3B');
    const offerId = get(event, 'offerId', 'OFZ7NI3WSMEX');
    const ctaText = get(event, 'ctaText', 'Upgrade for unlimited access.');
    const drawerCta = get(event, 'drawerCta', 'Subscribe to read more');
    const newData = {
      displayMessageFlag,
      displayMessageAt,
      templateId,
      offerId,
      ctaText,
      drawerCta
    };
    const updatedJourney = Object.assign(journey, newData);
    this.setState({
      journey: updatedJourney
    });
  }

  onSubscribe(event) {
    const { journey } = this.state;
    const displayMessageFlag = get(event, 'displayMessageFlag', true);
    const displayMessageAt = get(event, 'displayMessageAt', -1);
    const templateId = get(event, 'templateId', 'OTY37IX717TR');
    const offerId = get(event, 'offerId', 'OFC77Q9UWPQM');
    const ctaText = get(event, 'ctaText', 'Upgrade for unlimited access.');
    const drawerCta = get(event, 'drawerCta', 'Subscribe to read more');
    const newData = {
      displayMessageFlag,
      displayMessageAt,
      templateId,
      offerId,
      ctaText,
      drawerCta
    };
    const updatedJourney = Object.assign(journey, newData);
    this.setState({
      journey: updatedJourney,
      offerPageDetails: event
    });
  }

  // A Piano `offer` was triggered & displayed
  onShowOffer(offer) {
    handleShowOfferEvent(offer);
    // let offerId = get(offer, 'offerId', '');

    // if (
    //   this.isLoggedIn() &&
    //   this.isStudentOffer(offerId) &&
    //   !this.isStudentUser()
    // ) {
    //   // This is a non-student user attempting to view a student only offer
    //   this.setState({
    //     activeOffer: {
    //       failed: true,
    //       message: (
    //         <Fragment>
    //           <H2>Please use a valid student email address to qualify for this offer.</H2><br />
    //           <H3><a href="/subscribe">Not a student? Take a look at our other subscription offers!</a></H3>
    //         </Fragment>
    //       ),
    //     },
    //   });
    // }
  }

  onShowDrawer(event) {
    // console.log("💎🔥💎 DRAWER EVENT RECIEVED", event);
    const { displayMode, offerId, templateId, templateVariantId } = event;
    const target = `#drawerHolder-${this.state.currentDrawer}`;
    this.showOffer(offerId, templateId, displayMode, target, templateVariantId);
  }

  onOfferPage(event) {
    this.setState({
      offerPageDetails: event
    });
  }

  // // A Piano `template` was triggered & displayed
  // onShowTemplate = (response) => {}

  // A user has succesfully authenticated with Piano ID
  onLoginSuccess(loginResponse) {
    const myAccountRedirects = ['/login', '/register'];
    const userData = loginResponse;
    this.setCurrentUser(get(userData, 'params', {}));

    // Redirect certain routes
    if (
      myAccountRedirects.some(redirect =>
        get(window, 'location.href', '').includes(redirect)
      )
    ) {
      window.location.replace('/');
    }
  }

  // A user has succesfully registered and is now authenticated with Piano ID
  onRegisterSuccess(registerResponse) {
    const myAccountRedirects = ['/login', '/register'];
    const userData = registerResponse;
    this.setCurrentUser(get(userData, 'params', {}));

    // Redirect certain routes
    if (
      myAccountRedirects.some(redirect =>
        get(window, 'location.href', '').includes(redirect)
      )
    ) {
      window.location.replace('/');
    }
  }

  // A Piano `meter` is active
  onMeterActive(meterData) {
    this.setState({
      meter: meterData
    });
  }

  // An active Piano `meter` is expired
  onMeterExpired(expiredMeter) {
    this.setState({
      meter: expiredMeter
    });
  }

  // Listen for custom events defined in Piano templates
  onCustomEvent(event) {
    const { eventName, params } = event;
    const eventParams = JSON.parse(get(params, 'params', '{}')); // eslint-disable-line

    switch (eventName) {
      case 'offer-subscribe':
        // console.log('🎹 offer-subscribe event triggered: ', '\n', eventParams);
        break;
      case 'back_button_click':
        trackBackButtonClicked(event);
        break;
      case 'shipping_save':
        trackShippingSaveEvent(event);
        break;
      default:
        // console.log('✅ default case event triggered: ', '\n', event);
        break;
    }
  }

  // Map supplied set of handlers and attach to callback functions
  setPianoHandlers(handlers) {
    handlers.map(handler => {
      tp.push([ // eslint-disable-line
        'addHandler',
        handler,
        (data, secondary) => {
          this[`on${handler.charAt(0).toUpperCase() + handler.slice(1)}`](
            Object.assign({}, data, secondary)
          );
          return true;
        }
      ]);
      return true;
    });
  }

  // // A Piano offer's `term` has been selected
  // onCheckoutSelectTerm = (termData) => {
  //   let usePostCheckoutDebugger = get(window, 'location.href', '').includes('postcheckout');

  //   const isStudentOffer = this.isStudentOffer(get(termData, 'offerId', false));
  //   const iframeId = get(termData, 'secondary', undefined);

  //   if (
  //     this.isLoggedIn() &&
  //     this.isStudentOffer(get(termData, 'offerId', false)) &&
  //     !this.isStudentUser()
  //   ) {
  //     // This is a non-student user attempting to view a student only offer
  //     this.setState({
  //       activeOffer: {
  //         failed: true,
  //         message: (
  //           <Fragment>
  //             <H2>Please use a valid student email address to qualify for this offer.</H2><br />
  //             <H3><a href="/subscribe">Not a student? Take a look at our other subscription offers!</a></H3>
  //           </Fragment>
  //         ),
  //       },
  //     });

  //     tp.offer.close(); // Close the offer

  //     return false;
  //   }

  //   // Update state to reflect current offer term
  //   this.setState({
  //     activeOffer: termData,
  //   });

  //   // Handle term display access (student, etc.)
  //   if (isStudentOffer) {
  //     if (!this.isStudentUser()) {
  //       if(!usePostCheckoutDebugger){
  //         // PRE OFFER ALERT: "You are accessing a student offer with a non-student email."

  //         // this.showTemplate('OTWUVUE0WD0P'); // Generic hardcoded error template
  //         this.sendMessageToPiano(iframeId, false, '<h2>Sorry, you must be a student to access this offer.</h2><br /><h3>Please visit the <a href="https://www.inc.com/subscribe">Inc. Subscriptions</a> page for other great offers!</h3>', 'username');
  //         tp.offer.close();
  //       }else{
  //         // POST OFFER ALERT: "You got a student discount, please update your email to take advantage."
  //         tp.push(["addHandler", "checkoutComplete", function (conversion) {
  //           alert("POST-CHECKOUT: You signed up without an academic email. Please update your email. Checked after checkout.");
  //         }]);
  //       }
  //     }
  //   }
  // }

  // // Send custom data back to Piano iframe for use/display
  // sendMessageToPiano = (iframeId, success, message, object) => {
  //   var iframe = document.getElementById(iframeId);
  //   if (iframe) {
  //     iframe.contentWindow.postMessage({
  //       zig: 'zag',
  //       piano: {
  //         success: success,
  //         message: message,
  //         object: object
  //       }
  //     }, '*');
  //   }
  // }

  // /*------------------------------------------
  // * GETTERS & SETTERS FOR USER CONTEXT/STATE
  // * getUser, setUser, ...
  // --------------------------------------------*/
  // getCurrentUser = () => {
  //   return get(this.state, 'user', {});
  // }

  setCurrentUser(user) {
    this.setState({
      user
    });
  }

  listenForJourneyEvents(handlers) {
    // eslint-disable-next-line array-callback-return
    handlers.map(handler => {
      document.body.addEventListener(`${handler}`, event => {
        const eventResponse = get(event, 'detail', {});
        this[`on${handler.charAt(0).toUpperCase() + handler.slice(1)}`](
          eventResponse
        );
      });
    });
  }

  enableDebug() {
    this.setState({
      debugActive: true
    });
  }

  logoutUser() {
    // Logout local application state
    this.setState(
      {
        user: {}
      },
      () => {
        // Logout Piano state
        window.tp.push([
          'init',
          () => {
            tp.pianoId.logout((response) => { // eslint-disable-line
              // Redirect back to homepage
              // window.location.replace("/");
            });
          }
        ]);
      }
    );
  }

  /*------------------------------------------
  * SHOW OFFERS
  * screen.show, offer.show, template.show
  --------------------------------------------*/
  // Show a Piano offer to the user
  showOffer(
    offerId,
    templateId,
    displayMode = 'inline',
    selector = '',
    templateVariantId = ''
  ) {
    // console.log("showing offer at",selector);
    tp.push(["init", () => { // eslint-disable-line
        // Show the offer
      tp.offer.show({ // eslint-disable-line
          offerId,
          templateId,
          templateVariantId,
          displayMode,
          containerSelector: selector,
          loginSuccess: () => {}
        });
      }
    ]);
  }

  // Show any standard piano screen to the user
  showScreen(screen, mode, selector = '') {
    tp.push(['init', () => { // eslint-disable-line
      tp.pianoId.show({ // eslint-disable-line
          screen,
          displayMode: mode,
          containerSelector: selector
        });
      }
    ]);
  }

  showUserAccount(selector = '', displayMode = 'inline') {
    // eslint-disable-next-line no-undef
    tp.push([
      'init',
      () => {
        // eslint-disable-next-line no-undef
        tp.myaccount.show({
          displayMode,
          containerSelector: selector
        });
      }
    ]);
  }

  // showTemplate = (templateId) => {
  //   tp.push(["init", () => {
  //     tp.template.show({
  //       templateId: templateId
  //     });
  //   }]);
  // }

  // /*------------------------------------------
  // * HELPERS
  // * Functions to increase dev productivity
  // --------------------------------------------*/
  // isStudentUser = () => {
  //   const studentDomains = /.edu|.ac.uk|.ac.in|ac.za/;
  //   let currentUserEmail = get(this.state, 'user.email', '');
  //   return studentDomains.test(currentUserEmail);
  // }

  isLoggedIn() {
    const user = get(this.state, 'user', {});
    return !isEmpty(user);
  }

  /* eslint-disable no-undef */
  retriggerPianoPost(postData, currId) {
    this.setState({
      currentDrawer: currId
    });

    const tags = get(postData, 'tags', []);
    const eyeBrowText = figureOutPriorityTag(tags);

    let author = '';
    if (postData.author && postData.author.name !== '') {
      author = postData.author.name;
    }

    let primaryCategory = '';
    if (
      postData.categories &&
      postData.categories.length > 0 &&
      postData.categories[0] !== undefined
    ) {
      primaryCategory = postData.categories[0].name;
    }

    let subCategory = '';
    if (
      postData.categories &&
      postData.categories.length > 0 &&
      postData.categories[1] !== undefined
    ) {
      subCategory = postData.categories[1].name;
    } else {
      subCategory = primaryCategory;
    }

    const subSubCategory =
      get(eyeBrowText, 'slug') !== '' ? get(eyeBrowText, 'slug') : 'misc';

    const pubdate = postData.omnitureDate ? `${postData.omnitureDate}` : '';

    const isSponsored = !!tags.filter(tag => tag.name.includes('_advertorial'))
      .length;

    let pageType = 'article';
    if (get(postData, 'posterSlideshow.length')) {
      pageType = 'slideshow';
    } else if (
      get(postData, 'hasVideoPoster') === true ||
      get(postData, 'posterVideo.feedId')
    ) {
      pageType = 'video';
    }

    tp.push(['setContentSection', primaryCategory]);
    // tp.push(['setContentSection', subCategory]);
    tp.push(['setContentAuthor', author]);
    tp.push(['setContentCreated', pubdate]);
    tp.push(['setCustomVariable', 'primaryCategory', primaryCategory]);
    tp.push(['setCustomVariable', 'subCategory1', subCategory]);
    tp.push(['setCustomVariable', 'subCategory2', subSubCategory]);
    tp.push(['setCustomVariable', 'contentType', pageType]);
    tp.push(['setCustomVariable', 'articleType', pageType]);
    tp.push(['setCustomVariable', 'isSponsored', isSponsored]);
    tp.push(['setTags', tags.map(tag => tag.name)]);

    if (tp.experience) {
      tp.experience.execute();
    } else {
      // console.log("😱 No tp to experience!");
    }
  }

  // isStudentOffer = (offerId) => {
  //   const studentOffers = ['OFVEO4N0MX2A', 'OF8KNPZQK7KY']; // Array of all "student" offers
  //   return studentOffers.indexOf(offerId) > -1;
  // }

  // refreshMeter = () => {
  //   this.triggerExecute(); // Alert Piano of new execution
  // }

  // triggerExecute = () => {
  //   tp.push(["init", () => {
  //     tp.experience.execute();
  //   }]);
  // }

  render() {
    const finalState = {
      user: get(this.state, 'user', {}),
      meter: get(this.state, 'meter', {}),
      activeOffer: get(this.state, 'activeOffer', {}),
      journey: get(this.state, 'journey', {}),
      offerPageDetails: get(this.state, 'offerPageDetails', {}),
      isLoggedIn: this.isLoggedIn(),
      logoutUser: this.logoutUser,
      showScreen: this.showScreen,
      showOffer: this.showOffer,
      // refreshMeter: this.refreshMeter,
      showUserAccount: this.showUserAccount,
      retriggerPianoPost: this.retriggerPianoPost
    };

    return (
      <UserContext.Provider value={finalState}>
        {this.props.children}
        {get(this.state, 'debugActive', false) && (
          <Debugger
            trackedDataObject={{
              user: get(this.state, 'user', {}),
              meter: get(this.state, 'meter', {}),
              activeOffer: get(this.state, 'activeOffer', {}),
              journey: get(this.state, 'journey', {})
            }}
          />
        )}
      </UserContext.Provider>
    );
  }
}

UserProvider.propTypes = {
  children: PropTypes.shape({}).isRequired
};

export const UserConsumer = UserContext.Consumer;
